const getSeed = () => Math.random();

export default getSeed;
